const form = {
  formId: "new-user-form",
  formField: {
    id: {
      name: "id",
      label: "Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số",
    },
    date: {
      name: "date",
      label: "Ngày:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    sendTo: {
      name: "sendTo",
      label: "Kính gửi",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập nơi gửi đến",
    },
    payerName: {
      name: "date",
      label: "[01] Tên người nộp thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxID: {
      name: "taxID",
      label: "[02] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    address: {
      name: "address",
      label: "Ngày:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    agency: {
      name: "agency",
      label: "Đề nghị cơ quan thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế",
    },
    agencyName: {
      name: "agencyName",
      label: "[05] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập cơ quan thuế",
    },
    agencyTax: {
      name: "agencyTax",
      label: "[06] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: " Vui lòng nhập cơ quan thuế",
    },
    taxRefundDocument: {
      name: "taxRefundDocument",
      label: "Văn bản đề nghị hoàn thuế số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập văn bản",
    },
    taxRefundDate: {
      name: "taxRefundDate",
      label: "Ngày:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    tradeID: {
      name: "tradeID",
      label: "Mã giao dịch điện tử (nếu có):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    notificationReceivingAgency: {
      name: "notificationReceivingAgency",
      label: "Được cơ quan thuế tiếp nhận thông báo số :",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng cơ quan",
    },
    receivedDate: {
      name: "receivedDate",
      label: "Ngày :",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    why: {
      name: "why",
      label: "Lý do đề nghị hủy :",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập lý do",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Họ và tên:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên nhân viên đại lý thuế",
    },
    certificateNumber: {
      name: "certificateNumber",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    dateFounded: {
      name: "dateFounded",
      label: "Ngày ký:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

const AppendixForm = {
  formIdAppendix: "new-user-form",
  formFieldAppendix: {
    from: {
      name: "from",
      label: "Từ kỳ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập kỳ",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    to: {
      name: "to",
      label: "Đến kỳ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập kỳ",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    payerNameAppendix: {
      name: "payerNameAppendix",
      label: "[02].Tên người nộp thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxIdAppendix: {
      name: "taxId",
      label: "[03].Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentNameAppendix: {
      name: "taxAgentName",
      label: "[04] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCodeAppendix: {
      name: "taxAgentCode",
      label: "[05]Mã số thuế đại lý:",
      type: "text",
      placeholder: "Mã số thuế đại lý",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
  },
};

export { form, AppendixForm };
